<template>
    <modal ref="modal" unclosable>
        <div id="sub-wrapper">
            <div id="title" v-html="$t('modals.invalid_browser.title')"></div>
            <div id="text" v-html="$t('modals.invalid_browser.text')"></div>
            <div id="browsers">
              <img src="~@/assets/img/browser-chrome.png"/>
              <img src="~@/assets/img/browser-firefox.png"/>
            </div>
            <img id="img" src="~@/assets/img/invalid_device.png"/>
            <button v-on:click="hide">{{ $t('modals.invalid_browser.button') }}</button>
        </div>
    </modal>
</template>

<script>
export default {
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 30em;
}

#title {
  color: #000000;
  font-size: 2em;
  font-weight: 400;
  margin: 0 0 1em 0;
}

#text {
  margin: 0 0 1.5em 0;
}

#browsers {
  margin: 0 0 1em 0;
}

#browsers img {
  height: 3em;
  margin-right: 3em;
}

#browsers img:last-child {
  margin-right: 0;
}

#img {
  display: block;
  margin: auto auto 2em auto;
  width: 30em;
}

</style>
